import { useAtom } from 'jotai';
import { useCallback } from 'react';

import { checkoutFeaturesAtom } from '$src/business/atoms/checkout-features';
import { Shop } from '$src/hooks/queries';

export function useCheckoutFeaturesAtom() {
  const [features, setFeatures] = useAtom(checkoutFeaturesAtom);

  const onCheckoutFeaturesChange = useCallback(
    (shop: Shop) => {
      if (!shop || !Array.isArray(shop.features)) {
        console.warn('Invalid shop features:', shop?.features);
        return;
      }

      setFeatures(shop.features);
    },
    [setFeatures],
  );

  const canUseCheckoutFeature = useCallback(
    (feature: string) => {
      return new Set(features).has(feature);
    },
    [features],
  );

  return { features, canUseCheckoutFeature, onCheckoutFeaturesChange };
}

/**
 * This function is used to check if a feature is enabled for a shop in pure typescript
 * without using react stuff (server side)
 */
export function isFeatureEnabled(shop: Shop, feature: string) {
  if (!shop || !Array.isArray(shop.features)) {
    console.warn('Invalid shop features:', shop?.features);
    return false;
  }

  return new Set(shop.features).has(feature);
}
